/**
 * Validate box items
 *
 * Validate input number modulo step.
 * If modulo !== 0, round value up to fit step and show toast.
 */
define('utils/validate-box-items',['utils/string-interpolate', 'utils/translate', 'utils/toast'], function (s, t, Toast) {
  return function ($input) {
    var value = parseInt($input.val());
    var step = parseInt($input.attr('step'));
    if (!value || !step || step === 1) return;

    var stepDiff = value % step;
    if (stepDiff === 0) return;

    var newValue = value + step - stepDiff;
    $input.val(newValue);

    Toast.queue(s(t('Modified quantity to %1 to fit number of items in a box (%2)'), [newValue, step]));
  };
});

